function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import PropTypes from 'prop-types';
import { onResize } from '../../../../wdh-foundation/wdh';
var AccordionSpot = /*#__PURE__*/function (_React$Component) {
  function AccordionSpot(props) {
    var _this;
    _classCallCheck(this, AccordionSpot);
    _this = _callSuper(this, AccordionSpot, [props]);
    var expandAll = false;
    var expandedElements = [];
    if (_this.props.settings.expandAllOnLoad) {
      var _this$buildStateForEx = _this.buildStateForExpandAll();
      expandedElements = _this$buildStateForEx.expandedElements;
      expandAll = _this$buildStateForEx.expandAll;
    } else if (props.settings.expandItemOnLoad !== -1) {
      expandedElements = [props.settings.expandItemOnLoad];
    }
    var isDesktop = _this.props.resolveDesktop();
    _this.state = {
      expandedElements: expandedElements,
      expandAll: expandAll,
      isDesktop: isDesktop
    };
    _this.onElementTitleClick = _this.onElementTitleClick.bind(_this);
    _this.onExpandAllClick = _this.onExpandAllClick.bind(_this);
    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
    return _this;
  }
  _inherits(AccordionSpot, _React$Component);
  return _createClass(AccordionSpot, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;
      onResize(function () {
        var isDesktop = _this2.props.resolveDesktop();
        _this2.setState({
          isDesktop: isDesktop
        });
      });
    }
  }, {
    key: "onElementTitleClick",
    value: function onElementTitleClick(event, index) {
      event.preventDefault();
      var expandedElements = this.state.expandedElements;
      var expandedIndexForClickedElement = expandedElements.indexOf(index);
      if (expandedIndexForClickedElement !== -1) {
        expandedElements.splice(expandedIndexForClickedElement, 1);
      } else if (this.props.settings.allowMultipleItemsExpanded) {
        expandedElements.push(index);
      } else {
        expandedElements = [index];
      }
      var expandAll = expandedElements.length === 0 ? false : this.state.expandAll;
      expandAll = expandedElements.length === this.props.settings.elements.length ? true : expandAll;
      this.setState({
        expandedElements: expandedElements,
        expandAll: expandAll
      });
    }
  }, {
    key: "onExpandAllClick",
    value: function onExpandAllClick(event) {
      event.preventDefault();
      var _expandedElements$exp = {
          expandedElements: [],
          expandAll: false
        },
        expandedElements = _expandedElements$exp.expandedElements,
        expandAll = _expandedElements$exp.expandAll;
      if (!this.state.expandAll) {
        var _this$buildStateForEx2 = this.buildStateForExpandAll();
        expandedElements = _this$buildStateForEx2.expandedElements;
        expandAll = _this$buildStateForEx2.expandAll;
      }
      this.setState({
        expandedElements: expandedElements,
        expandAll: expandAll
      });
    }
  }, {
    key: "getStyles",
    value: function getStyles() {
      if (!this.state.isDesktop && this.hasValue('mobileBackgroundImage')) {
        return {
          backgroundImage: "url(".concat(this.props.settings.mobileBackgroundImage, ")")
        };
      } else if (this.state.isDesktop && this.hasValue('desktopBackgroundImage')) {
        return {
          backgroundImage: "url(".concat(this.props.settings.desktopBackgroundImage, ")")
        };
      }
      return {};
    }
  }, {
    key: "buildStateForExpandAll",
    value: function buildStateForExpandAll() {
      return {
        expandedElements: this.props.settings.elements.map(function (element, index) {
          return index;
        }),
        expandAll: true
      };
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(event, callback) {
      if (event.keyCode === 13) {
        for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          rest[_key - 2] = arguments[_key];
        }
        callback.apply(this, [].concat(rest));
      }
    }
  }, {
    key: "hasValue",
    value: function hasValue(key) {
      var object = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var lookUpObject = object || this.props.settings;
      return lookUpObject[key] && lookUpObject[key] !== '';
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      return /*#__PURE__*/React.createElement("div", {
        className: "accordion-spot-elements",
        itemScope: true,
        itemType: this.hasValue('microdataenabled') ? 'https://schema.org/FAQPage' : '',
        style: this.getStyles()
      }, this.hasValue('microdataenabled') && this.hasValue('shrinkAllLabel') && /*#__PURE__*/React.createElement("div", {
        className: "accordion-spot-elements__expand-all ".concat(this.state.expandAll ? 'shrink-all' : 'expand-all'),
        onClick: this.onExpandAllClick,
        role: "button",
        onKeyPress: function onKeyPress(event) {
          _this3.handleKeyPress(event, _this3.onExpandAllClick);
        },
        tabIndex: "0"
      }, this.state.expandAll ? this.props.settings.shrinkAllLabel : this.props.settings.expandAllLabel), this.props.settings.elements.map(function (element, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: "accordion-element-".concat(index),
          className: "accordion-spot-element ".concat(_this3.state.expandedElements.indexOf(index) !== -1 ? 'expand' : 'shrink'),
          "data-index": index + 1,
          itemScope: true,
          itemProp: _this3.hasValue('microdataenabled') ? 'mainEntity' : '',
          itemType: _this3.hasValue('microdataenabled') ? 'https://schema.org/Question' : ''
        }, /*#__PURE__*/React.createElement("div", {
          className: "accordion-spot-element__title",
          onClick: function onClick(event) {
            _this3.onElementTitleClick(event, index);
          },
          role: "button",
          onKeyPress: function onKeyPress(event) {
            _this3.onElementTitleClick(event, _this3.onExpandAllClick, index);
          },
          tabIndex: index + 1,
          itemProp: _this3.hasValue('microdataenabled') ? 'name' : ''
        }, element.title), /*#__PURE__*/React.createElement("div", {
          className: "accordion-spot-element__content",
          itemScope: true,
          itemProp: _this3.hasValue('microdataenabled') ? 'acceptedAnswer' : '',
          itemType: _this3.hasValue('microdataenabled') ? 'https://schema.org/Answer' : ''
        }, _this3.hasValue('header', element) && /*#__PURE__*/React.createElement("div", {
          className: "accordion-spot-element__header"
        }, element.header), _this3.hasValue('body', element) && /*#__PURE__*/React.createElement("div", {
          className: "accordion-spot-element__body",
          itemProp: _this3.hasValue('microdataenabled') ? 'text' : '',
          dangerouslySetInnerHTML: {
            __html: element.body
          }
        })));
      }));
    }
  }]);
}(React.Component);
AccordionSpot.propTypes = {
  settings: PropTypes.shape({
    mobileBackgroundImage: PropTypes.string,
    desktopBackgroundImage: PropTypes.string,
    expandAllLabel: PropTypes.string,
    shrinkAllLabel: PropTypes.string,
    allowMultipleItemsExpanded: PropTypes.bool,
    expandItemOnLoad: PropTypes.number,
    expandAllOnLoad: PropTypes.bool,
    elements: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      header: PropTypes.string,
      body: PropTypes.string
    }))
  }),
  resolveDesktop: PropTypes.func.isRequired
};
AccordionSpot.defaultProps = {
  settings: {
    mobileBackgroundImage: '',
    desktopBbackgroundImage: '',
    expandAllLabel: '',
    shrinkAllLabel: '',
    allowMultipleItemsExpanded: false,
    expandItemOnLoad: 0,
    expandAllOnLoad: false,
    elements: []
  }
};
export default AccordionSpot;